// extracted by mini-css-extract-plugin
export default {"coverSpin":"BackdropSpinner_coverSpin__G3z7m","spin":"BackdropSpinner_spin__lb1af","messages":"BackdropSpinner_messages__+D6Ot","hidden":"BackdropSpinner_hidden__KCvbV"};